// Helpers para persistir el estado del onboarding wizard en localStorage,
// scoped por storeKey para evitar colisiones entre tiendas.

const STORAGE_PREFIX = "fengcart:onboarding:";
export const TOS_VERSION = "v1";

const getStorageKey = (storeKey) => `${STORAGE_PREFIX}${storeKey || "anonymous"}`;

const getDefaultState = () => ({
  step: 1,
  completed: false,
  dismissed: false,
  answers: {
    email: "",
    phone: "",
    wantsApp: null,
    licenseChoice: null,
    acceptedTos: false,
    acceptedTosVersion: null,
    acceptedTosAt: null,
    wantsDesignService: null,
    designServiceNotes: "",
  },
});

export const getWizardState = (storeKey) => {
  try {
    const raw = localStorage.getItem(getStorageKey(storeKey));
    if (!raw) {
      return getDefaultState();
    }
    const parsed = JSON.parse(raw);
    const defaults = getDefaultState();
    return {
      ...defaults,
      ...parsed,
      answers: {
        ...defaults.answers,
        ...(parsed.answers || {}),
      },
    };
  } catch (error) {
    console.error("Error reading onboarding state:", error);
    return getDefaultState();
  }
};

export const saveWizardState = (storeKey, partial) => {
  try {
    const current = getWizardState(storeKey);
    const next = {
      ...current,
      ...partial,
      answers: {
        ...current.answers,
        ...(partial.answers || {}),
      },
    };
    localStorage.setItem(getStorageKey(storeKey), JSON.stringify(next));
    return next;
  } catch (error) {
    console.error("Error saving onboarding state:", error);
    return null;
  }
};

export const markCompleted = (storeKey) => {
  return saveWizardState(storeKey, { completed: true });
};

export const markDismissed = (storeKey) => {
  return saveWizardState(storeKey, { dismissed: true });
};

export const resetWizardState = (storeKey) => {
  try {
    localStorage.removeItem(getStorageKey(storeKey));
  } catch (error) {
    console.error("Error resetting onboarding state:", error);
  }
};
